// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.25 13.75L7.4 8.6',
  'M9.75 1.75V3.25M9.75 9.25V10.75M5.25 6.25H6.75M12.75 6.25H14.25',
  'M7.63 4.13L6.57 3.07M11.87 4.13L12.93 3.07M11.87 8.37L12.93 9.43',
  'M9.75 6.25H9.76',
];
